"use strict";

angular.module("open-iti")
	.controller("OpenFormUserCtrl", [
		"$scope", "toastr", "AdminService", "$uibModal", "Utils", "subscribersUser",
		function ($scope, toastr, AdminService, $uibModal, Utils, subscribersUser) {

		$scope.data = {
			subscribersUser: subscribersUser.data
		};

	}]);

